import React, { useState } from "react";
import styled from "styled-components";
import AfterVisit from "./AfterVisit";

// Styled Components
const Container = styled.div`
  max-width: 98%;
  margin: 50px auto;
  padding: 20px 30px;
  background-color: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const ItemBar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
`;

const ItemName = styled.div`
  width: 20%;
  font-weight: normal;
  font-size: 12px;
  color: #0000a0;
`;

const BarWrapper = styled.div`
  width: 100%;
  display: flex;
  position: relative;
`;

const Bar = styled.div`
  background-color: #8e6bce;
  height: 12.5px;
  width: ${(props) => props.percentage}%;
`;

const Percentage = styled.div`
  margin-left: 10px;
  color: #0000a0;
  margin-right: 10px;
  font-size: 12px;
`;

const NumberOfEvents = styled.div`
  margin-bottom: 20px;
  font-size: 11px;
  color: #3e4ba8;
  font-weight: bold;
`;

const TabMenu = styled.div`
  display: flex;
  margin-bottom: 20px;

  & > div {
    margin-right: 20px;
    cursor: pointer;
    color: #3e4ba8;
    font-weight: bold;
    font-size: 5px;
    border-bottom: 2px solid transparent;
    padding-bottom: 2px;
  }
`;

const ItemList = ({ data }) => {
  return (
    <>
      {data.map((item, index) => {
        const percentage = (item.totalcount * 100) / (item.countryVisited || 1);
        return (
          <ItemBar key={index}>
            <ItemName>{item.countryName}</ItemName>
            <BarWrapper>
              <Bar percentage={percentage} />
              <Percentage>{Math.round(percentage)}%</Percentage>
            </BarWrapper>
          </ItemBar>
        );
      })}
    </>
  );
};

const AssociateList = ({ value }) => {
  const maxbarCount = 100;
  return (
    <>
      {value.map((data, index) => {
        return (
          <ItemBar key={index}>
            <ItemName>{data.associatesCategory}</ItemName>
            <BarWrapper>
              <Bar
                percentage={Math.min(
                  (data.associateCount / maxbarCount) * 100,
                  100
                )}
              />
              <Percentage>{data.associateCount}</Percentage>
            </BarWrapper>
          </ItemBar>
        );
      })}
    </>
  );
};

const CountryList = ({
  totalEventCount,
  countrybarData,
  eventCountAssociates,
  totalAssociatesCount
}) => {
  const [activeTab, setActiveTab] = useState("COUNTRIES");

  const renderContent = () => {
    switch (activeTab) {
      case "COUNTRIES":
        return <ItemList data={countrybarData} count={totalEventCount} />;
      case "ASSOCIATES":
        return (
          <AssociateList
            value={eventCountAssociates}
          />
        );
      case "AFTER VISIT":
        return <AfterVisit />;
      default:
        return null;
    }
  };

  const tabs = ["COUNTRIES", "ASSOCIATES", "AFTER VISIT"];

  return (
    <Container>
      <TabMenu>
        {tabs.map((tab) => (
          <div
            key={tab}
            className={`nav-item-custom ${
              tab === activeTab ? "nav-link active" : "nav-link"
            }`}
            style={{ fontSize: "20px !important" }}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </div>
        ))}
      </TabMenu>

      {/* Check if countries array is not empty and if the first country has 'countryVisited' */}
      {activeTab === "COUNTRIES" &&
      countrybarData.length > 0 &&
      countrybarData[0].countryVisited !== null ? (
        <NumberOfEvents>
          NUMBER OF EVENT ON ACTIVE SELECTION: {totalEventCount}
        </NumberOfEvents>
      ) : activeTab === "ASSOCIATES" &&
        eventCountAssociates.length > 0 &&
        eventCountAssociates[0].associateCount !== null ? (
        <NumberOfEvents>
          NUMBER OF EVENT ON ACTIVE SELECTION: {totalAssociatesCount}
        </NumberOfEvents>
      ) : (
        <NumberOfEvents></NumberOfEvents>
      )}

      <div style={{ height: "350px", overflowY: "auto" }}>
        {renderContent()}
      </div>
    </Container>
  );
};

export default CountryList;